
export const getFilename =  (layerName: string): string => layerName.replace(":", "_")